/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnDestroy, OnInit} from '@angular/core';
import * as _ from 'lodash';

import {AngularResourceListManager} from '../common/controller/angular-resource-list-manager';
import {ApiErrorHandlerService} from '../common/directives/error/api-error-handler.service';
import {AuthHttpInterceptorService} from '../../components/auth/auth-http-interceptor.service';
import {AdnHttpService} from '../../components/util/adn-http.service';
import {LocalUserProfile} from '../../components/session/local-user-profile';
import {WINDOW} from '../angular-platform-providers';

const BASE_TITLE = 'payments';
const PAYMENT_LIST_ID = 'fullPaymentList';
const CSV_COLUMNS = ['createTime', 'provider', 'status', 'statusTimestamp', 'amount', 'billedAmount', 'refundedAmount', 'receiptUrl', 'appliedCouponName', 'appliedCouponId', 'couponDiscountAmount', 'lineItemName', 'lineItemId'];
const CSV_HEADINGS = ['Payment Time', 'Payment Service', 'Status', 'Status Date', 'Budgeted Amount', 'Billed Amount', 'Refunded Amount', 'Receipt URL', 'Coupon', 'Coupon ID', 'Coupon Amount', 'Line Item', 'Line Item ID'];
const ADJUSTMENT_COLUMNS = {
  appliedCouponId: ['appliedCoupon', 'id'],
  appliedCouponName: ['appliedCoupon', 'name'],
  lineItemName: ['lineItem', 'name'],
  lineItemId: ['lineItem', 'id']
};

@Component({
  standalone: false,
  selector: 'adn-payment-route-page',
  template: `
    <adn-payment-list-page
      *ngIf="list"
      [list]="list">
    </adn-payment-list-page>
  `
})
export class PaymentRoutePageComponent implements OnInit, OnDestroy {
  list: any;
  private listManager: AngularResourceListManager;

  constructor(
    private readonly AdnHttp: AdnHttpService,
    private readonly authHttpInterceptor: AuthHttpInterceptorService,
    private readonly ApiErrorHandler: ApiErrorHandlerService,
    @Inject(LocalUserProfile) private localUserProfile: any,
    @Inject(WINDOW) private window: any,
    private ngZone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.listManager = new AngularResourceListManager({
      AdnHttp: this.AdnHttp,
      authHttpInterceptor: this.authHttpInterceptor,
      ApiErrorHandler: this.ApiErrorHandler,
      window: this.window,
      localUserProfile: this.localUserProfile,
      ngZone: this.ngZone
    }, {
      resourcePath: 'payment',
      listId: PAYMENT_LIST_ID,
      defaultOrderByParam: 'DESCcreateTime',
      exportConfig: {
        baseTitle: BASE_TITLE,
        columns: CSV_COLUMNS,
        headingFields: CSV_HEADINGS,
        mapItem: (item: any) => {
          _.forEach(ADJUSTMENT_COLUMNS, (path, key) => {
            item[key] = _.get(item, path);
          });
          return item;
        }
      }
    });
    this.list = this.listManager.list;
    this.listManager.load();
  }

  ngOnDestroy(): void {
    this.listManager?.destroy();
  }
}
